import { HelpOutline } from "@mui/icons-material";
import { FC, ReactNode } from "react";
import css from "./Explanation.module.css";
import { Tooltip } from "@mui/material";

const Explanation: FC<{ children: ReactNode }> = function ({ children }) {
  return (
    <span className={css.explanation}>
      <Tooltip title={children} slotProps={{ popper: { disablePortal: true } }}>
        <HelpOutline className={css.icon} />
      </Tooltip>
    </span>
  );
};

export default Explanation;
